import type { InputLayoutControlProps } from './InputLayout'

export const extractProps = <T extends InputLayoutControlProps>({
  error,
  label,
  required,
  slim,
  prepareLabelMargins,
  prepareErrorMargins,
  id,
  className,
  ...rest
}: T) =>
  [
    {
      error,
      label,
      required,
      slim,
      prepareLabelMargins,
      prepareErrorMargins,
      id,
      className,
    },
    rest,
  ] as const
